import { Routes } from '@angular/router';
import { HomeComponent } from './componentes/home/home.component';
import { PanelAdminComponent } from './componentes/panel-admin/panel-admin.component';
import { LoginComponent } from './componentes/login/login.component';
import { PlanificacionComponent } from './componentes/planificacion/planificacion.component';
import { ListarRolesComponent } from './componentes/listar-roles/listar-roles.component';
import { ReprogramacionComponent } from './componentes/ejecucion/reprogramacion/reprogramacion.component';
import { AccionesFormativasComponent } from './componentes/ejecucion/acciones-formativas/acciones-formativas.component';
import { ListarEstudiantesComponent } from './componentes/usuarios/listar-estudiantes/listar-estudiantes.component';
import { ListarInstitucionalesComponent } from './componentes/usuarios/listar-institucionales/listar-institucionales.component';
import { CargaMasivaInstitucionalComponent } from './componentes/usuarios/carga-masiva-institucional/carga-masiva-institucional.component';
import { CargaMasivaParticipanteComponent } from './componentes/usuarios/carga-masiva-participante/carga-masiva-participante.component';
import { BancoAspirantesComponent } from './componentes/planificacion-cumplimiento/banco-aspirantes/banco-aspirantes.component';
import { ContratacionAspiranteComponent } from './componentes/planificacion-cumplimiento/contratacion-aspirante/contratacion-aspirante.component';
import { CatalagoComponent } from './componentes/catalago/catalago.component';
import { EvaluacionEtComponent } from './componentes/evaluacion-et/evaluacion-et.component';
import { EstudioCumplmientoComponent } from './componentes/evaluacion-et/estudio-cumplmiento/estudio-cumplmiento.component';
import { InscripcionComponent } from './componentes/ejecucion/inscripcion/inscripcion.component';
import { EmergenciaComponent } from './componentes/emergencia/emergencia.component';
import { authGuard } from './custom/auth.guard';

export const routes: Routes = [
  { path: "", component: HomeComponent },
  { path: "login", component: LoginComponent },
  { path: "catalago", component: CatalagoComponent },
  {
    path: "panel-admin", component: PanelAdminComponent, canActivate: [authGuard], children: [
      { path: "", component: HomeComponent },
      { path: "catalago_admin", component: CatalagoComponent },
      { path: "planificacion", component: PlanificacionComponent },
      { path: "listar-roles", component: ListarRolesComponent },
      { path: "reprogramacion", component: ReprogramacionComponent },
      { path: "acciones-formativas", component: AccionesFormativasComponent },
      { path: "listar-usuarios-participantes", component: ListarEstudiantesComponent },
      { path: "listar-usuarios-institucionales", component: ListarInstitucionalesComponent },
      { path: "carga-masiva-participante", component: CargaMasivaParticipanteComponent },
      { path: "carga-masiva-institucional", component: CargaMasivaInstitucionalComponent },
      { path: "banco-aspirantes", component: BancoAspirantesComponent },
      { path: "contratacion-aspirante", component: ContratacionAspiranteComponent },
      { path: "calculo-cuota", component: EvaluacionEtComponent },
      { path: "estudio-cumplmiento", component: EstudioCumplmientoComponent },
      { path: "inscripcion", component: InscripcionComponent },
      { path: "emergencia", component: EmergenciaComponent },
    ]
  }
];
